var scope_0 = require('/Users/me/aaa/github/personalsite/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8d2b55c5cbdcad53721ba29f64c72622.js').default;
var scope_1 = require('/Users/me/aaa/github/personalsite/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8eaf91adbc09a2ee99cc8b79c30ca046.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    